var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none",
    viewBox: "0 0 13 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.714 9.714c-.509 0-.978.179-1.346.477l-3.7-2.677a2.9 2.9 0 0 0 0-1.028l3.7-2.677c.368.298.837.477 1.346.477 1.182 0 2.143-.961 2.143-2.143S11.897 0 10.714 0a2.145 2.145 0 0 0-2.059 2.738L5.141 5.281a2.856 2.856 0 1 0-2.284 4.575c.934 0 1.763-.448 2.284-1.14l3.514 2.545q-.083.286-.084.595c0 1.182.961 2.143 2.143 2.143s2.143-.96 2.143-2.143-.96-2.143-2.143-2.143m0-8.5a.929.929 0 1 1 0 1.858.929.929 0 0 1 0-1.858M2.857 8.571A1.574 1.574 0 0 1 1.286 7c0-.866.705-1.571 1.571-1.571S4.43 6.134 4.43 7s-.706 1.571-1.572 1.571m7.857 4.215a.929.929 0 1 1 .001-1.858.929.929 0 0 1 0 1.858"
  })));
};
export default SvgShare;